import { useState } from 'react'
import { toast } from 'sonner'
import { Button, Dialog, Input } from './common'

export default function InviteLinkDialog({ url, expiresAt, onClose }) {
  const [copyFailed, setCopyFailed] = useState(false)
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url)
      setCopyFailed(false)
      toast.success('Link copied')
    } catch {
      setCopyFailed(true)
    }
  }

  return (
    <Dialog
      open
      title="Invite link"
      description={`Earlier links stop working; this one expires ${new Date(expiresAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}.`}
      onClose={onClose}
      footer={<Button onClick={copyLink}>Copy link</Button>}
    >
      <Input aria-label="Invite link" value={url} readOnly onFocus={(event) => event.target.select()} />
      {copyFailed ? <p role="status">Select the link and copy it manually.</p> : null}
    </Dialog>
  )
}
